// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Tn-z","badgeLink":"Un-z","category":"Vn-z"};